export type Role = "owner" | "editor" | "viewer" | "hardware" | "firmware" | "review" | "guest";

export const ORG = { slug: "pcbx", name: "pcbx Lab" };
export const PROJECT = { slug: "ad9152-evt1", name: "AD9152 EVT1" };
export const USER = { id: "user_xz", name: "XZ", email: "xz@pcbx.ai", role: "owner" as Role };

export const REQUIREMENTS = [
  { id: "req_sfdr", title: "SFDR ≥ 70 dBc at 1.5 GSPS", status: "accepted", git_path: "docs/requirements/sfdr.md" },
  { id: "req_clock", title: "Low-jitter clock tree for DAC", status: "in_impl", git_path: "docs/requirements/clock.md" },
  { id: "req_evt1", title: "EVT1 bring-up: USB + 12V rail", status: "draft", git_path: "docs/requirements/evt1.md" },
];

export const HARDWARE_REVS = [
  { id: "hw_r3", label: "r3", git_oid: "e4f5a6b7c8d9e0f1a2b3", kicad_tree: "hardware/", mind_path: "design.mind" },
  { id: "hw_r2", label: "r2", git_oid: "a1b2c3d4e5f607189abc", kicad_tree: "hardware/", mind_path: "design.mind" },
  { id: "hw_r1", label: "r1", git_oid: "9aa11bb22cc33dd44ee5", kicad_tree: "hardware/", mind_path: null },
];

export const ISSUES = [
  {
    id: "iss_bias",
    number: 12,
    title: "Bias network drift on IOUT",
    git_ref: "feat/evt1-bias",
    path: "hardware/analog/bias.kicad_sch",
    workstream: "hardware",
    status: "open",
  },
  {
    id: "iss_clk",
    number: 11,
    title: "Clock buffer OE default",
    git_ref: "main",
    path: "hardware/clock/clk_buf.kicad_sch",
    workstream: "hardware",
    status: "open",
  },
];

export const REVIEWS = [
  {
    id: "drv_bias",
    title: "EVT1 analog bias + clock",
    from_ref: "a1b2c3d",
    to_ref: "e4f5a6b",
    workstream: "hardware",
    status: "ready",
    findings: 3,
    checks: "agent_findings 3 · import_kicad ok",
  },
];

export const MILESTONES = [
  { id: "mil_evt1", name: "EVT1", status: "open", target: "2026-10-15" },
  { id: "mil_dvt", name: "DVT", status: "open", target: null },
  { id: "mil_pvt", name: "PVT", status: "open", target: null },
];

export const JOBS = [
  { id: "job_import_r3", kind: "import_kicad", state: "succeeded", ref: "r3", started: "11:02" },
  { id: "job_check_r3", kind: "agent_findings", state: "queued", ref: "e4f5a6b", started: "11:04" },
  { id: "job_scene", kind: "scene", state: "running", ref: "e4f5a6b", started: "11:05" },
];

export const MEMBERS = [
  { user: "xz@pcbx.ai", role: "owner" as Role },
  { user: "hw@pcbx.ai", role: "hardware" as Role },
  { user: "fw@pcbx.ai", role: "firmware" as Role },
];

export const LIBRARIES = [{ id: "adi-highspeed-dac", kind: "part_dossier", git_url: "https://github.com/pcbx/parts" }];
